import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../../../../context/userContext'
import CopyToClipboard from '../../../../../assets/images/copyToClipboard'
import './ChooseURL.scss'
import { generateLink } from '../../../../../utils/uploadFile'
const PREVIEW_URL = "https://flimp.live/";

const Link = ({ to, message }) => {
    const handleCopy = () => {
        navigator.clipboard.writeText(to);
    }
    if (message) {
        return (
            <div className='message error sm fade-in'>{message}</div>
        )
    }
    if (to)
        return (
            <div className='copyToClipboard fade-in'>
                {to}
                <div>
                    <CopyToClipboard onClick={handleCopy} />
                    <span>Link copied!</span>
                </div>
            </div>
        )
}

export const ChooseURL = ({ file, onLinkChange }) => {
    const { userID, sessionID } = useContext(UserContext);
    const [customLink, setCustomLink] = useState("")
    const [link, setLink] = useState(null);
    const [message, setMessage] = useState(null);

    useEffect(() => {
        if (file && !file.fileId) {
            setCustomLink("");
            setLink(null)
            setMessage(null)
            onLinkChange({ target: { value: null } });
        }
    }, [file]);

    const handleOnLinkChange = (e) => {
        const { value } = e.target;
        setCustomLink(value)
    }

    const generateCustomLink = () => {
        if (customLink.length) {
            setLink(null);
            generateLink(file.fileId, userID, sessionID, customLink)
                .then(res => {
                    setLink(res.data)
                    onLinkChange({ target: { value: res.data } });
                })
                .catch(err => {
                    setMessage(err.message);
                    onLinkChange({ target: { value: null } });
                    setTimeout(() => {
                        setMessage(null)
                    }, 5000);
                });
        }
    }

    const randomizeLink = () => {
        setLink(null);
        generateLink(file.fileId, userID, sessionID)
            .then(res => {
                setLink(res.data)
                onLinkChange({ target: { value: res.data } });
            })
            .catch(err => {
                setMessage(err.message);
                onLinkChange({ target: { value: null } });
                setTimeout(() => {
                    setMessage(null)
                }, 5000);
            });
    }

    if (file && file.fileId)
        return (
            <div className='chooseUrl fade-in'>
                <b>Choose URL</b>
                <p>Create a custom Link</p>
                <div className='link'>
                    <div>
                        <div className='link-input'>
                            <span>{PREVIEW_URL}</span>
                            <input
                                value={customLink}
                                onChange={handleOnLinkChange}
                                placeholder={"your-custom-link"}
                                type="text"
                            />
                        </div>
                        <Link to={link} message={message} />
                    </div>
                    <button className={`primary ${customLink.length < 5 ? "disabled" : ""}`} onClick={generateCustomLink}>Generate Link</button>
                    <button className="secondary" onClick={randomizeLink}>Randomize</button>
                </div>
            </div>
        )
}
